function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { numberFormat, declension } from '../helpers';
import { sortBy } from 'lodash';
import Lenis from '@studio-freight/lenis';
var Mortgage = /*#__PURE__*/ function() {
    "use strict";
    function Mortgage() {
        var _Math;
        _class_call_check(this, Mortgage);
        var _window_ranges;
        _define_property(this, "banks", sortBy(banksData, 'rate'));
        _define_property(this, "$banksRoot", document.querySelector('[data-mortgage-banks]'));
        _define_property(this, "banksList", {
            list: this.banks,
            page: 1,
            showCount: 4
        });
        _define_property(this, "$filters", {
            price: document.querySelector('[data-mortgage-price]  .range-input'),
            initialPayment: document.querySelector('[data-mortgage-initial-payment] .range-input'),
            term: document.querySelector('[data-mortgage-term] .range-input'),
            program: document.querySelector('[data-mortgage-program]'),
            clear: document.querySelector('[data-mortgage-clear]')
        });
        _define_property(this, "initialPayment", {
            min: (_Math = Math).min.apply(_Math, _to_consumable_array(this.banks.map(function(el) {
                return el.initialPayment;
            }))),
            max: 80,
            root: (_window_ranges = window.ranges) === null || _window_ranges === void 0 ? void 0 : _window_ranges.find(function(item) {
                return item.target.closest('[data-mortgage-initial-payment]');
            }),
            //root: document.querySelector('[data-mortgage-initial-payment]'),
            percent: 30,
            percent_default: 30
        });
        _define_property(this, "default", {
            price: this.$filters.price.value,
            initialPayment: this.$filters.initialPayment.value,
            term: this.$filters.term.value,
            program: this.$filters.program.value
        });
        _define_property(this, "clear", false);
    }
    _create_class(Mortgage, [
        {
            key: "handleInitialPaymentOptions",
            value: function handleInitialPaymentOptions() {
                var _this_initialPayment_root;
                (_this_initialPayment_root = this.initialPayment.root) === null || _this_initialPayment_root === void 0 ? void 0 : _this_initialPayment_root.updateOptions({
                    range: {
                        min: 0,
                        max: 5000000
                    }
                });
            }
        },
        {
            key: "handleMonthPayment",
            value: function handleMonthPayment(rate) {
                var S = this.$filters.price.value - this.$filters.initialPayment.value;
                var P = rate / 12 / 100;
                var M = this.$filters.term.value * 12;
                return Math.round(S * (P / (1 - Math.pow(1 + P, -M))));
            }
        },
        {
            key: "handleCreateBanks",
            value: function handleCreateBanks() {
                if (this.clear) return false;
                var self = this;
                var params = "price=".concat(this.$filters.price.value, "&initial_payment=").concat(this.$filters.initialPayment.value, "&loan_period=").concat(this.$filters.term.value).concat(this.$filters.program.value == "all" ? "" : "&type=" + this.$filters.program.value);
                var params1 = "price=".concat(this.$filters.price.value, "&initial_payment=").concat(this.$filters.initialPayment.value, "&loan_period=30");
                // Создание объекта XMLHttpRequest
                var xhr = new XMLHttpRequest();
                // Настройка запроса
                xhr.open('GET', location.protocol + '//' + location.host + '/ajax/mortgage-list.php?' + params, true);
                var responseObject;
                // Установка обработчика для обработки ответа
                xhr.onload = function() {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        responseObject = JSON.parse(xhr.responseText);
                        self.banksList.page = 1;
                        fetch(location.protocol + '//' + location.host + '/ajax/mortgage-list.php?' + params1).then(function(response) {
                            return response.json();
                        }).then(function(data) {
                            var calculateMonthlyPayment = function calculateMonthlyPayment(principal, annualInterestRate, numberOfPayments) {
                                var monthlyInterestRate = annualInterestRate / 100 / 12;
                                var numerator = monthlyInterestRate * Math.pow(1 + monthlyInterestRate, numberOfPayments);
                                var denominator = Math.pow(1 + monthlyInterestRate, numberOfPayments) - 1;
                                var monthlyPayment = principal * numerator / denominator;
                                return monthlyPayment;
                            };
                            var formatNumberWithSpaces = function formatNumberWithSpaces(number) {
                                // Округлить число до ближайшего целого
                                var roundedNumber = Math.round(number);
                                // Форматирование числа с пробелами для разделения тысяч
                                return new Intl.NumberFormat('ru-RU').format(roundedNumber);
                            };
                            // Полученные данные в формате JSON теперь доступны в переменной 'data'
                            // Можно работать с полученными данными как с объектом JavaScript
                            var filteredByType27 = Object.values(data.data).filter(function(obj) {
                                return obj.program == 27;
                            }); // Стандартная
                            var filteredByType29 = self.banksList.list.filter(function(obj) {
                                return obj.program == 29;
                            }); // Семейная
                            var priceNotes = document.querySelectorAll('.room-preview__price-note');
                            priceNotes.forEach(function(priceNote) {
                                priceNote.addEventListener('click', function(event) {
                                    event.preventDefault();
                                    event.stopPropagation();
                                });
                            });
                            /*const minRateType27 = filteredByType27.reduce((min, obj) => {
					 return obj.rate < min ? obj.rate : min;
				   }, Infinity);

				   const minRateType29 = filteredByType29.reduce((min, obj) => {
					 return obj.rate < min ? obj.rate : min;
				   }, Infinity);*/ //document.getElementById('minRateType27').textContent = `${minRateType27}%`;
                            //document.getElementById('minRateType29').textContent = `${minRateType29}%`;
                            var programType27 = filteredByType27[0];
                            var rateType27 = programType27.rate;
                            var initialType27 = programType27.initialPayment;
                            var programType29 = filteredByType29[0];
                            var rateType29 = programType29.rate;
                            var initialType29 = programType29.initialPayment;
                            document.getElementById('minRateType27').textContent = "".concat(rateType27, "%");
                            document.getElementById('minRateType29').textContent = "".concat(rateType29, "%");
                            document.getElementById('fp-standart').textContent = "".concat(initialType27, "%");
                            document.getElementById('fp-family').textContent = "".concat(initialType29, "%");
                            var principal1 = self.$filters.price.value / 100 * (100 - initialType27); // сумма кредита
                            var principal2 = self.$filters.price.value / 100 * (100 - initialType29); // сумма кредита
                            var annualInterestRate1 = rateType27; // годовая процентная ставка
                            var annualInterestRate2 = rateType29; // годовая процентная ставка
                            var numberOfPayments = 30 * 12; // срок кредита в месяцах (30 лет)
                            var monthlyPayment1 = calculateMonthlyPayment(principal1, annualInterestRate1, numberOfPayments);
                            var monthlyPayment2 = calculateMonthlyPayment(principal2, annualInterestRate2, numberOfPayments);
                            if (document.getElementById('mp-standart')) {
                                document.getElementById('mp-standart').textContent = "".concat(formatNumberWithSpaces(monthlyPayment1), "₽");
                                document.getElementById('mp-family').textContent = "".concat(formatNumberWithSpaces(monthlyPayment2), "₽");
                                document.getElementById('pr-standart').textContent = "".concat(formatNumberWithSpaces(monthlyPayment1 - monthlyPayment2), "₽");
                                document.getElementById('pr-standart-label').textContent = monthlyPayment1 > monthlyPayment2 ? 'Больше' : 'Меньше';
                                document.getElementById('pr-standart-arrow').setAttribute('d', monthlyPayment1 > monthlyPayment2 ? 'M12 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 12 2.5C6.48 2.5 2 6.98 2 12.5C2 18.02 6.48 22.5 12 22.5ZM8.47 11.47L11.47 8.47C11.62 8.32 11.81 8.25 12 8.25C12.19 8.25 12.38 8.32 12.53 8.47L15.53 11.47C15.82 11.76 15.82 12.24 15.53 12.53C15.24 12.82 14.76 12.82 14.47 12.53L12.75 10.81L12.75 16C12.75 16.41 12.41 16.75 12 16.75C11.59 16.75 11.25 16.41 11.25 16L11.25 10.81L9.53 12.53C9.24 12.82 8.76 12.82 8.47 12.53C8.18 12.24 8.18 11.76 8.47 11.47Z' : 'M12 2.5C6.48 2.5 2 6.98 2 12.5C2 18.02 6.48 22.5 12 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 12 2.5ZM15.53 13.53L12.53 16.53C12.38 16.68 12.19 16.75 12 16.75C11.81 16.75 11.62 16.68 11.47 16.53L8.47 13.53C8.18 13.24 8.18 12.76 8.47 12.47C8.76 12.18 9.24 12.18 9.53 12.47L11.25 14.19V9C11.25 8.59 11.59 8.25 12 8.25C12.41 8.25 12.75 8.59 12.75 9V14.19L14.47 12.47C14.76 12.18 15.24 12.18 15.53 12.47C15.82 12.76 15.82 13.24 15.53 13.53Z');
                                document.getElementById('pr-family').textContent = "".concat(formatNumberWithSpaces(monthlyPayment1 - monthlyPayment2), "₽");
                                document.getElementById('pr-family-label').textContent = monthlyPayment2 > monthlyPayment1 ? 'Больше' : 'Меньше';
                                document.getElementById('pr-family-arrow').setAttribute('d', monthlyPayment2 > monthlyPayment1 ? 'M12 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 12 2.5C6.48 2.5 2 6.98 2 12.5C2 18.02 6.48 22.5 12 22.5ZM8.47 11.47L11.47 8.47C11.62 8.32 11.81 8.25 12 8.25C12.19 8.25 12.38 8.32 12.53 8.47L15.53 11.47C15.82 11.76 15.82 12.24 15.53 12.53C15.24 12.82 14.76 12.82 14.47 12.53L12.75 10.81L12.75 16C12.75 16.41 12.41 16.75 12 16.75C11.59 16.75 11.25 16.41 11.25 16L11.25 10.81L9.53 12.53C9.24 12.82 8.76 12.82 8.47 12.53C8.18 12.24 8.18 11.76 8.47 11.47Z' : 'M12 2.5C6.48 2.5 2 6.98 2 12.5C2 18.02 6.48 22.5 12 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 12 2.5ZM15.53 13.53L12.53 16.53C12.38 16.68 12.19 16.75 12 16.75C11.81 16.75 11.62 16.68 11.47 16.53L8.47 13.53C8.18 13.24 8.18 12.76 8.47 12.47C8.76 12.18 9.24 12.18 9.53 12.47L11.25 14.19V9C11.25 8.59 11.59 8.25 12 8.25C12.41 8.25 12.75 8.59 12.75 9V14.19L14.47 12.47C14.76 12.18 15.24 12.18 15.53 12.47C15.82 12.76 15.82 13.24 15.53 13.53Z');
                                var imageGalleryDiv = document.getElementById('bank-family');
                                for(var i = 0; i < Math.min(5, filteredByType29.length); i++){
                                    var imageContainer = document.createElement('div');
                                    imageContainer.classList.add('image-container');
                                    var image = document.createElement('img');
                                    image.src = filteredByType29[i].image;
                                    imageContainer.appendChild(image);
                                    imageGalleryDiv.appendChild(imageContainer);
                                }
                                // Вставка div с длиной массива
                                var arrayLengthDiv = document.createElement('div');
                                arrayLengthDiv.textContent = "".concat(filteredByType29.length - 5, "+");
                                imageGalleryDiv.appendChild(arrayLengthDiv);
                                var imageGalleryDiv2 = document.getElementById('bank-standart');
                                for(var i1 = 0; i1 < Math.min(5, filteredByType27.length); i1++){
                                    var imageContainer2 = document.createElement('div');
                                    imageContainer2.classList.add('image-container');
                                    var image2 = document.createElement('img');
                                    image2.src = filteredByType27[i1].image;
                                    imageContainer2.appendChild(image2);
                                    imageGalleryDiv2.appendChild(imageContainer2);
                                }
                                // Вставка div с длиной массива
                                var arrayLengthDiv2 = document.createElement('div');
                                arrayLengthDiv2.textContent = "".concat(filteredByType27.length - 5, "+");
                                imageGalleryDiv2.appendChild(arrayLengthDiv2);
                            }
                        }).catch(function(error) {
                            console.error('Ошибка при получении данных:', error);
                        });
                        self.banksList.list = Object.values(responseObject.data).map(function(item) {
                            return _object_spread_props(_object_spread({}, item), {
                                monthPayment: self.handleMonthPayment(item.rate)
                            });
                        });
                        var banksCount = self.banksList.list.length;
                        self.$banksRoot.innerHTML = '\n			<div class="mortgage__count">подобрано '.concat(banksCount, " ").concat(declension('программа', 'программ', 'программы', banksCount), "</div>\n			").concat(self.banksList.list.length > 0 ? '\n						<div class="mortgage__list">\n							'.concat(self.banksList.list.filter(function(item, index) {
                            return index < self.banksList.showCount;
                        }).map(function(item) {
                            return Mortgage.bankTemplate(item);
                        }).join(''), "\n						</div>\n					") : '\n						<div class="mortgage__empty"><div>ничего не найдено</div><span>Попробуйте задать другие параметры</span></div>\n					', "\n\n			").concat(banksCount > self.banksList.showCount ? '<button class="button button_inline mortgage__more" data-mortgage-more><span>показать ещё</span></button>' : '', "\n		");
                        window.lenis.resize();
                    } else {
                        console.error('Ошибка при выполнении запроса:', xhr.statusText);
                    }
                };
                // Обработка ошибок
                xhr.onerror = function() {
                    console.error('Запрос не удался');
                };
                // Отправка запроса
                xhr.send();
            }
        },
        {
            key: "handleNextPage",
            value: function handleNextPage() {
                var start = this.banksList.showCount * this.banksList.page;
                this.banksList.page += 1;
                var end = this.banksList.showCount * this.banksList.page - 1;
                var bankList = this.$banksRoot.querySelector('.mortgage__list');
                if (bankList) {
                    bankList.insertAdjacentHTML('beforeend', this.banksList.list.filter(function(item, index) {
                        return index >= start && index <= end;
                    }).map(function(item) {
                        return Mortgage.bankTemplate(item);
                    }).join(''));
                    if (this.banksList.list.length <= this.banksList.showCount * this.banksList.page) {
                        var _document_querySelector;
                        (_document_querySelector = document.querySelector('[data-mortgage-more]')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.remove();
                    }
                }
                window.lenis.resize();
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                setTimeout(function() {
                    window.lenis.destroy();
                    window.lenis = new Lenis({
                        autoResize: true,
                        normalizeWheel: true,
                        duration: 1
                    });
                    window.lenis.resize();
                    function raf(time) {
                        window.lenis.raf(time);
                        requestAnimationFrame(raf);
                    }
                    requestAnimationFrame(raf);
                }, "1000");
                var touchAreas = document.querySelectorAll('.mortgage__fields .field__slider');
                var self = this;
                touchAreas.forEach(function(touchArea) {
                    touchArea.addEventListener('mouseup', function() {
                        self.handleCreateBanks();
                        var elementToRemove = document.getElementById('select-mort');
                        if (elementToRemove) {
                            elementToRemove.remove();
                        }
                    });
                    touchArea.addEventListener('touchend', function() {
                        self.handleCreateBanks();
                        var elementToRemove = document.getElementById('select-mort');
                        if (elementToRemove) {
                            elementToRemove.remove();
                        }
                    });
                });
                this.handleInitialPaymentOptions();
                this.handleCreateBanks();
                this.$filters.price.addEventListener('change', function() {
                    var _window_ranges_find;
                    document.getElementById('select-mort').remove();
                    _this.handleInitialPaymentOptions();
                    //const initialPayment = (this.$filters.price.value * (this.initialPayment.percent_default / 100)).toFixed(0)
                    var initialPayment = Math.ceil(_this.initialPayment.percent_default / 100 * _this.$filters.price.value);
                    (_window_ranges_find = window.ranges.find(function(item) {
                        return item.target.closest('[data-mortgage-initial-payment]');
                    })) === null || _window_ranges_find === void 0 ? void 0 : _window_ranges_find.updateOptions({
                        range: {
                            min: Math.ceil(0.16 * _this.$filters.price.value),
                            max: Math.ceil(0.9 * _this.$filters.price.value)
                        },
                        start: initialPayment
                    });
                    _this.$filters.initialPayment.value = initialPayment;
                    _this.banksList.list = _this.banksList.list.map(function(item) {
                        return _object_spread_props(_object_spread({}, item), {
                            monthPayment: _this.handleMonthPayment(item.rate)
                        });
                    });
                    var bankList = _this.$banksRoot.querySelector('.mortgage__list');
                    if (bankList) {
                        bankList.innerHTML = _this.banksList.list.filter(function(item, index) {
                            return index < _this.banksList.showCount * _this.banksList.page;
                        }).map(function(item) {
                            return Mortgage.bankTemplate(item);
                        }).join('');
                    }
                });
                this.$filters.initialPayment.addEventListener('change', function() {
                    _this.initialPayment.percent = (_this.$filters.initialPayment.value / _this.$filters.price.value * 100).toFixed(0);
                    _this.handleCreateBanks();
                });
                this.$filters.term.addEventListener('change', function() {
                    _this.handleCreateBanks();
                    document.getElementById('select-mort').remove();
                });
                this.$filters.program.addEventListener('input', function() {
                    _this.handleCreateBanks();
                    document.getElementById('select-mort').remove();
                });
                this.$filters.price.addEventListener('change', function() {
                    _this.handleCreateBanks();
                    document.getElementById('select-mort').remove();
                });
                var container = document.getElementById('container');
                if (container) {
                    container.addEventListener('mouseup', function(event) {
                        // Проверяем, был ли элемент с классом noUi-touch-area
                        if (event.target.classList.contains('noUi-touch-area')) {}
                    });
                }
                document.addEventListener('click', function(event) {
                    var $el = event.target;
                    if ($el.dataset.mortgageMore !== undefined) {
                        _this.handleNextPage();
                    }
                    if ($el.dataset.bankRequest !== undefined) {
                        var $fieldParams = document.querySelector('[data-mortgage-field-params]');
                        var $fieldBank = document.querySelector('[data-mortgage-field-bank]');
                        if ($fieldParams) $fieldParams.value = JSON.stringify({
                            price: _this.$filters.price.value,
                            initialPayment: _this.$filters.initialPayment.value,
                            term: _this.$filters.term.value,
                            program: _this.$filters.program.value
                        });
                        if ($fieldBank) $fieldBank.value = $el.dataset.bankRequest;
                        window.modal.open('mortgage');
                    }
                });
                this.$filters.clear.addEventListener('click', function() {
                    var _window_ranges_find, _window_ranges_find1, _window_ranges_find2;
                    _this.clear = true;
                    _this.$filters.program.closest('.dropdown').querySelector('[data-dropdown-id="'.concat(_this.default.program, '"]')).dispatchEvent(new CustomEvent('click'));
                    (_window_ranges_find = window.ranges.find(function(item) {
                        return item.target.closest('[data-mortgage-price]');
                    })) === null || _window_ranges_find === void 0 ? void 0 : _window_ranges_find.updateOptions({
                        start: _this.default.price
                    });
                    _this.$filters.price.value = _this.default.price;
                    _this.$filters.price.dispatchEvent(new CustomEvent('change'));
                    (_window_ranges_find1 = window.ranges.find(function(item) {
                        return item.target.closest('[data-mortgage-term]');
                    })) === null || _window_ranges_find1 === void 0 ? void 0 : _window_ranges_find1.updateOptions({
                        start: _this.default.term
                    });
                    _this.$filters.term.value = _this.default.term;
                    (_window_ranges_find2 = window.ranges.find(function(item) {
                        return item.target.closest('[data-mortgage-initial-payment]');
                    })) === null || _window_ranges_find2 === void 0 ? void 0 : _window_ranges_find2.updateOptions({
                        range: {
                            min: Math.ceil(0.16 * _this.default.price),
                            max: Math.ceil(0.9 * _this.default.price)
                        },
                        start: _this.default.initialPayment
                    });
                    /*			this.initialPayment.root?.updateOptions({
							start: this.default.initialPayment
						})*/ _this.$filters.initialPayment.value = _this.default.initialPayment;
                    var initialTimeout = setTimeout(function() {
                        _this.clear = false;
                        _this.handleCreateBanks();
                        clearTimeout(initialTimeout);
                    }, 0);
                });
            }
        }
    ], [
        {
            key: "bankTemplate",
            value: function bankTemplate(bankData) {
                return "\n			<div class=".concat(bankData.periodParams && bankData.periodParams.length > 0 ? "bank extend" : 'bank', '>\n				<div class="bank__logo">\n					<div><img src="').concat(bankData.image, '" alt=""></div>\n\n				</div>\n\n				<div class="bank__params">\n					<ul class="list">\n						<li class="list__item">\n							<div class="list__value">').concat(bankData.title, '</div>\n\n						</li>\n						<li class="list__item">\n							<div class="list__value">').concat(bankData.periodParams.length > 0 ? bankData.periodParams[0].rate : bankData.rate, '%</div>\n							<div class="list__label">').concat(bankData.rateTitle ? bankData.rateTitle : 'ставка', '</div>\n						</li>\n						<li class="list__item">\n							<div class="list__value">').concat(bankData.initialPayment, '%</div>\n							<div class="list__label">взнос от</div>\n						</li>\n			<li class="list__item">\n							<div class="list__value">').concat(bankData.term / 12, " ").concat(declension('год', 'лет', 'года', bankData.term / 12), '</div>\n							<div class="list__label">срок до</div>\n						</li>\n						<li class="list__item">\n							<div class="list__value">').concat(bankData.periodParams.length > 0 ? numberFormat(Math.round(bankData.periodParams[0].monthlyPayment / 100)) : numberFormat(bankData.monthPayment), ' <span class="rub">₽</span></div>\n							<div class="list__label">ежемесячный платёж</div>\n						</li>\n					</ul>\n				</div>\n				<div class="bank__control">\n					<button data-bank-request=\'').concat(JSON.stringify(bankData), "'>Оставить заявку</button>\n				</div>\n				").concat(bankData.footnote ? '<div class="bank__footnote">'.concat(bankData.footnote, "</div>") : '', "\n							   ").concat(bankData.periodParams.length > 0 ? '<div class="bank__mort-desk">\n								<div>Ставка '.concat(bankData.periodParams[1].rate, "% с ").concat(bankData.periodParams[0].months + 1, "-го месяца</div>\n												<div>Платеж ").concat(numberFormat(Math.round(bankData.periodParams[1].monthlyPayment / 100)), " ₽ с ").concat(bankData.periodParams[0].months + 1, "-го месяца</div>\n								</div>") : '', "\n			</div>\n		");
            }
        }
    ]);
    return Mortgage;
}();
export default Mortgage;
